import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    private isLoadingSubject = new BehaviorSubject<boolean | null>(null);
    public isLoading$ = this.isLoadingSubject.asObservable();

    public showLoader(): void {
        if (!this.isLoadingSubject.value) {
            this.isLoadingSubject.next(true);
        }
    }

    public hideLoader(): void {
        if (this.isLoadingSubject.value) {
            this.isLoadingSubject.next(false);
        }
    }
}
